import React, { useCallback, useEffect, useState } from 'react'
import apiClient from '../../services/api'
import { useToast } from '../../context/ToastContext'
import LoadingSpinner from '../../components/LoadingSpinner'

const AdminTestimonials = () => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [form, setForm] = useState({ name: '', message: '' })
  const [editId, setEditId] = useState(null)
  const { addToast } = useToast()

  const load = useCallback(async () => {
    try {
      const res = await apiClient.get('/api/cms/testimonials')
      setItems(res.data)
    } catch (e) { addToast('Error loading testimonials', 'danger') } finally { setLoading(false) }
  }, [addToast])

  useEffect(() => {
    const initialLoad = async () => {
      try {
        const res = await apiClient.get('/api/cms/testimonials')
        setItems(res.data)
      } catch (e) {
        addToast('Error loading testimonials', 'danger')
      } finally {
        setLoading(false)
      }
    }

    initialLoad()
  }, [addToast])

  const save = async (e) => {
    e.preventDefault()
    try {
      if (editId) {
        await apiClient.put(`/api/cms/testimonials/${editId}`, form)
      } else {
        await apiClient.post('/api/cms/testimonials', form)
      }
      addToast(editId ? 'Testimonial updated' : 'Testimonial created', 'success')
      setForm({ name: '', message: '' })
      setEditId(null)
      load()
    } catch (e) { addToast('Error saving testimonial', 'danger') }
  }

  const remove = async (id) => {
    if (!window.confirm('Delete testimonial?')) return
    await apiClient.delete(`/api/cms/testimonials/${id}`)
    addToast('Deleted', 'success'); load()
  }

  if (loading) return <LoadingSpinner />

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h2>Testimonials</h2>
          <p>
            Keep patient feedback current with a cleaner edit flow and a simple list that is easier to scan before it goes live on the homepage.
          </p>
        </div>
      </div>

      <div className="card p-3 mb-4 shadow-sm admin-form-card">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <h5 className="mb-0">{editId ? 'Edit Testimonial' : 'Add Testimonial'}</h5>
          {editId && (
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                setForm({ name: '', message: '' })
                setEditId(null)
              }}
            >
              Cancel Edit
            </button>
          )}
        </div>
        <form onSubmit={save} className="row g-3">
          <div className="col-md-4">
            <input
              placeholder="Patient name"
              value={form.name}
              onChange={(event) => setForm({ ...form, name: event.target.value })}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <textarea
              placeholder="Patient feedback"
              value={form.message}
              onChange={(event) => setForm({ ...form, message: event.target.value })}
              className="form-control"
              rows="3"
              required
            />
          </div>
          <div className="col-md-2 d-flex align-items-start">
            <button className="btn btn-primary w-100" type="submit">{editId ? 'Update' : 'Add'}</button>
          </div>
        </form>
      </div>

      <div className="admin-note mb-3">{items.length} testimonial{items.length === 1 ? '' : 's'} saved</div>

      <div className="admin-card-list">
        {items.map((item) => (
          <div className="card shadow-sm" key={item._id}>
            <div className="card-body">
              <h5>{item.name}</h5>
              <p className="mb-3">{item.message}</p>
              <div className="admin-action-group">
                <button className="btn btn-sm btn-secondary" onClick={() => { setForm({ name: item.name, message: item.message }); setEditId(item._id) }}>Edit</button>
                <button className="btn btn-sm btn-danger" onClick={() => remove(item._id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdminTestimonials
